import React from 'react';
import HealthData from './HealthData';
import BaseHealthDataFilterForm from './Filter/BaseHealthDataFilterForm';

interface BaseHealthDataProps {
	patientId: string;
}

const BaseHealthData: React.FC<BaseHealthDataProps> = props => (
	<HealthData {...props} FilterComponent={BaseHealthDataFilterForm} />
);

export default BaseHealthData;
